import { render } from "./ReportsList.vue?vue&type=template&id=2786463a&scoped=true"
import script from "./ReportsList.vue?vue&type=script&lang=js"
export * from "./ReportsList.vue?vue&type=script&lang=js"

import "./ReportsList.vue?vue&type=style&index=0&id=2786463a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2786463a"]])

export default __exports__